import { render, staticRenderFns } from "./CreateDeliveryNoteStats.vue?vue&type=template&id=efa45f00&lang=pug&"
import script from "./CreateDeliveryNoteStats.vue?vue&type=script&lang=ts&"
export * from "./CreateDeliveryNoteStats.vue?vue&type=script&lang=ts&"
import style0 from "./CreateDeliveryNoteStats.vue?vue&type=style&index=0&id=efa45f00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports